import { useTabParam } from "@/features/workspaces/tab-params-context";
import { useParams } from "@tanstack/react-router";

/**
 * Hook that gets route parameters from either:
 * 1. Workspace tab params (when in workspace mode)
 * 2. TanStack Router params (when in normal navigation mode)
 *
 * This allows components to work in both contexts.
 */
export function useRouteParam(key: string): string | undefined {
  // Call all hooks unconditionally at the top
  const tabParam = useTabParam(key);
  const params = useParams({ strict: false });

  // Prefer tab param when in workspace mode, otherwise use router params
  if (tabParam) {
    return tabParam;
  }
  return (params as Record<string, string | undefined>)[key];
}
